import { render, staticRenderFns } from "./AppNotification.vue?vue&type=template&id=35c9784a&scoped=true&"
import script from "./AppNotification.vue?vue&type=script&lang=js&"
export * from "./AppNotification.vue?vue&type=script&lang=js&"
import style0 from "./AppNotification.vue?vue&type=style&index=0&id=35c9784a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c9784a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VAlert,VSlideXTransition})
